let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hoJ3M")).then(() => parcelRequire('7lyg2'));